import { Model } from "pinia-orm";

export default class AosPicture extends Model {
  static entity = "aos_pictures";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      aosItem: this.string(""),
      pictureUuid: this.string(""),
      pictureUrl: this.string(""),
      pictureName: this.string(""),
      title: this.string(""),
      year: this.attr(null),
      observation: this.string(""),
      isMain: this.attr(null),
    };
  }
}
